goog.provide('el8.uiwidget.alert');
goog.provide('el8.uiwidget.alertHTML');
goog.provide('el8.uiwidget.alertInternet');
goog.provide('el8.uiwidget.alertLogin');
goog.provide('el8.uiwidget.alertConfirm');
goog.provide('el8.uiwidget.confirm');
goog.provide('el8.uiwidget.nonAlarmingAlert');
goog.provide('el8.uiwidget.titleFreeConfirm');
goog.provide('el8.uiwidget.deleteConfirm');

goog.require('el8.template.uiwidget.alert');
goog.require('el8.util.consts');


/**
 * This file is an Elation replacement for the browser built-in
 * alert() / confirm() functions. It uses the jqModal library
 * (with custom styles) to present a couple variants on:
 *      - Tell the user something
 *      - Ask for a yes/no answer on something
 *
 * Pretty match any matching uses of el8.uiwidget.alert/el8.uiwidget.confirm
 * should be reasonable to copy here; this one is pretty simple.
 */
(function() {

    var Alerter = (function() {

        var isInit = false;
        var isVisible = false;

        var container = null;

        var yesBtn = null;
        var noBtn = null;
        var customBtn = null;
        var alertMsg = null;

        var prefWidth = 480;

        var yesFocusField = null;

        function init() {

            container = $(el8.template.uiwidget.alert.content());
            $(document.body).append(container);
            container.jqm({
                modal: true,
                overlay: 30
            });
            container.addClass('auto-dialog');

            yesBtn = $('.alert-yes-btn', container);
            noBtn = $('.alert-no-btn', container);
            customBtn = $('.alert-custom-btn', container);
            alertMsg = $('#alert-message', container);

            isInit = true;
        }


        function setTitle(title) {
            $('.alert-title', container).html(el8.template.uiwidget.alert.title({title: title}));
        }

        return {

            _initYesBtn: function(opts) {
                var that = this;
                if (!opts) {
                    yesBtn.hide();
                } else {
                    if (opts.isDelete || false) {
                        yesBtn.removeClass('el8AlertButton').addClass('el8DeleteButton');
                    } else {
                        yesBtn.removeClass('el8DeleteButton').addClass('el8AlertButton');
                    }

                    if (!opts.noFocus) { yesBtn.focus(); }

                    yesBtn.unbind('click').on('click', function(event) {
                        event.preventDefault();
                        event.stopPropagation();
                        that.hide();
                        if (opts.fn) { opts.fn(); }
                        if (yesFocusField) { yesFocusField.focusSelect(); }
                    }).text(opts.text || 'OK').show();
                }
            },

            _initNoBtn: function(opts) {
                var that = this;
                if (!opts) {
                    noBtn.hide();
                } else {
                    noBtn.unbind('click').on('click', function(event) {
                        event.preventDefault();
                        event.stopPropagation();
                        that.hide();
                        if (opts.fn) { opts.fn(); }
                    }).text(opts.text || 'No').show();
                }
            },

            _initCustomBtn: function(opts) {
                var that = this;
                if (!opts || !opts.text) {
                    customBtn.hide();
                } else {
                    customBtn.unbind('click').on('click', function(event) {
                        that.hide();
                        if (opts.fn) { opts.fn(); }
                        return false;
                    }).text(opts.text).show();
                }
            },

            show: function(spec) {
                var that = this;
                if (!isInit) { init(); }
                if (isVisible) { that.hide(); }

                container.jqmShow();
                isVisible = true;

                yesFocusField = spec.yesFocusField || null;

                setTitle(spec.title || '');
                if (spec.msgTemplateFn) {
                    // this should always use a soy template
                    alertMsg.html(spec.msgTemplateFn());
                } else {
                    alertMsg.text(spec.msg || 'Alert!');
                }

                prefWidth = spec.prefWidth || prefWidth;

                that._initYesBtn(spec.yesOpts || null);
                that._initNoBtn(spec.noOpts || null);
                that._initCustomBtn(spec.customOpts || null);

                container.css('z-index', 8000);
                container.css('top', '50%');
                container.css('left', '50%');
                container.css('-ms-transform', 'translate(-50%, -50%)');
                container.css('transform', 'translate(-50%, -50%)');
                container.css('width', prefWidth);
                container.css('max-width', 'calc(100% - 50px)');
                if (spec.prefHeight) {
                    container.css('height', spec.prefHeight);
                }
                container.css('max-height', 'calc(100% - 50px)');
                return this;
            },
            hide: function() {
                alertMsg.empty();
                container.jqmHide();
                isVisible = true;
                return this;
            }
        };
    })();

    /**
     * A single button dialog with big text that says "ALERT."
     * Generally used to notify the user that something is wrong.
     */
    el8.uiwidget.alert = function(msg, okFocusField, yesFn, yesBtnText) {
        if (!msg) { return; }
        Alerter.show({
            title: 'ALERT',
            msg: msg,
            yesFocusField: okFocusField,
            yesOpts: {
                text: yesBtnText || 'OK',
                fn: yesFn ? yesFn : null
            }
        });
    };

    /**
     * Two button dialog with big text that says "ALERT."
     * Generally used to notify the user that something is wrong.
     * @param {string} msg - Alert message
     * @param {boolean} okFocusField - Focus set on ok/yes button
     * @param {Function} yesFn - Calls function if yes button is selected
     * @param {string} yesBtnText - Yes button text
     * @param {Function} noFn - Calls function if no button is selected
     * @param {string} noBtnText - No button text
     */
     el8.uiwidget.alertConfirm = function(msg, okFocusField, yesFn, yesBtnText, noFn, noBtnText) {
        if (!msg) { return; }
        Alerter.show({
            title: 'ALERT',
            msg: msg,
            yesFocusField: okFocusField,
            yesOpts: {
                text: yesBtnText || 'OK',
                fn: yesFn ? yesFn : null
            },
            noOpts: {
                text: noBtnText ? noBtnText : 'Cancel',
                fn: noFn ? noFn : null
            },
        });
    };

     /**
     * Like the standard alert, but renders HTML in the dialog.
     * A single button dialog with big text that says "ALERT."
     * Generally used to notify the user that something is wrong.
     */
    el8.uiwidget.alertHTML = function(msg, okFocusField, yesFn, yesBtnText) {
        if (!msg) { return; }
        Alerter.show({
            title: 'ALERT',
            msgTemplateFn: function () { return msg; },
            yesFocusField: okFocusField,
            yesOpts: {
                text: yesBtnText || 'OK',
                fn: yesFn ? yesFn : null
            }
        });
    };

    /**
     * A single button dialog with no big text.
     * Used to let the user know something more important than a notifier message
     * but not scary.
     */
    el8.uiwidget.nonAlarmingAlert = function(msg, opts) {
        if (!msg) { return; }
        opts = opts || {};
        Alerter.show({
            title: '',
            msg: msg,
            yesOpts: {
                text: 'OK'
            },
            prefHeight: opts.prefHeight || 195
        });
    };

    /**
     * A Yes/No dialog with big text that says "Confirm."
     *
     * For confirming deletions with stronger accidental prevention use deleteConfirm
     */
    el8.uiwidget.confirm = function(msg, yesFn, noFn, opts) {
        opts = opts || {};
        var yesBtnText = opts.yesBtnText ? opts.yesBtnText : 'Yes';
        var noBtnText = opts.noBtnText ? opts.noBtnText : 'No';
        var msgTemplateFn = opts.msgTemplateFn ? opts.msgTemplateFn: null;
        var confirmArgs = {
            title: opts.title ? opts.title : 'Confirm',
            msg: msg,
            yesOpts: {
                text: yesBtnText,
                fn: yesFn ? yesFn : null
            },
            noOpts: {
                text: noBtnText,
                fn: noFn ? noFn : null
            },
            customOpts: opts.customBtnOpts,
            prefWidth: opts.prefWidth
        };
        if (opts.prefHeight) {
            confirmArgs.prefHeight = opts.prefHeight;
        }
        if (opts.msgTemplateFn) {
            confirmArgs.msgTemplateFn = opts.msgTemplateFn;
        }
        Alerter.show(confirmArgs);
    };

    /**
     * Like confirm above, but additions to prevent accidental deletions with:
     *
     * 1. more space for more title text
     * 2. red 'yes, delete' button is not focused by default
     *
     * - Wraps `msg` with standard "Are you sure you want to permanently delete this" and "can't
     *   undo!" copy
     * - Sends "isDelete" flag to show() to alter the yes button class
     */
    el8.uiwidget.deleteConfirm = function(msg, yesFn, noFn, opts) {
        opts = opts || {};

        // `opts.msgOverride` is a new option that allows callers to specify that the given
        // message should completely override the internal behavior of this function,
        // i.e. it should NOT have standardized text additionally prepended/appended to it.
        var finalMsg = opts.msgOverride
          ? msg
          : "Are you sure you want to permanently delete this " + msg + "?";

        var confirmArgs = {
            title: opts.title ? opts.title : 'This action cannot be undone!',
            msg: finalMsg,
            yesOpts: {
                text: opts.yesBtnText ? opts.yesBtnText : 'Yes, delete',
                fn: yesFn ? yesFn : null,
                noFocus: true,
                isDelete: true
            },
            noOpts: {
                text: opts.noBtnText ? opts.noBtnText : 'No, cancel',
                fn: noFn ? noFn : null
            },
            msgTemplateFn: opts.msgTemplateFn ? opts.msgTemplateFn: null,
            customOpts: opts.customBtnOpts,
            prefHeight: opts.prefHeight ? opts.prefHeight : null,
            prefWidth: opts.prefWidth ? opts.prefWidth : el8.util.consts.DELETE_CONFIRM_DIALOG_WIDTH
        };

        Alerter.show(confirmArgs);
    };

    /**
     * A Yes/No dialog with no big text.
     * Used liked confirm() above, except that it has room for more complicated text,
     * because it doesn't lose a big block of text to the dialog title.
     */
    el8.uiwidget.titleFreeConfirm = function(opts) {
        opts = opts || {};
        var yesBtnText = opts.yesBtnText ? opts.yesBtnText : 'Yes';
        var noBtnText = opts.noBtnText ? opts.noBtnText : 'No';
        var confirmArgs = {
            title: '',
            msgTemplateFn: opts.msgTemplateFn,
            yesOpts: {
                text: yesBtnText,
                fn: opts.yesFn ? opts.yesFn : null
            },
            noOpts: {
                text: noBtnText,
                fn: opts.noFn ? opts.noFn : null
            },
            customOpts: opts.customBtnOpts
        };
        if (opts.prefHeight) {
            confirmArgs.prefHeight = opts.prefHeight;
        }
        Alerter.show(confirmArgs);
    };

})();
